import { ColDef } from "ag-grid-community";
import {
  idColumn,
  actionColumn,
  // statusColumn,
  lastNameColumn,
  firstNameColumn,
} from "../../../../../utils/commonColumns";
import { generateColumn, renderNA, setDateFilterDefs } from "../../../../../utils/commonFunctions";
import { useAppDispatch } from "../../../../../utils/hooks/hooks";
import { fetchRolesList } from "../../../../../store/CommonSlice";
import { dateFormatter } from "../../../../../config/Global";
import { dateFormats } from "../../utils/constants";
import { useAppSelector } from "../../../../../utils/hooks/hooks";
import { RootState } from "../../../../../store/app";
import { Tag, Typography } from "antd";
const { Title, Link } = Typography;

const AccessCodeColumnDefs = () => {
  const dispatch = useAppDispatch();
  const customerAccessDetails = useAppSelector((state: RootState) => state.customerAccess.details);


  const statusAll = [
    { color: '#108ee9', title: 'Available', disabled: '0' },
    { color: 'green', title: 'Registered', disabled: '1' },
    { color: '#87d068', title: 'Invited', disabled: '1' },
    { color: '#FF0000', title: 'Expired', disabled: '1' },
  ]

  const statusFileds = (index: number, type: string) => {
    var i = 0;
    if(customerAccessDetails?.is_completed)
    {
       i = (customerAccessDetails.is_completed == 'Completed' && index != 2) ? 3 : index;
    }

    if (type == 'color') {
      return statusAll[i].color;
    }
    else if (type == 'disabled') {
      return statusAll[i].disabled;
    }
    else {
      return statusAll[i].title;
    }
  }

  const AceessCodeColumn: ColDef = {
    field: "enc_code",
    width: 500,
    headerName: "Access Code",
    cellRenderer: (props: any) => {
      return <Title level={4} type="secondary" code>{renderNA(props.data.enc_code)}</Title>;
    },
  };
  const UserEmailColumn: ColDef = {
    ...generateColumn("Registered Email", "user_email"),
    width: 500,
    cellRenderer: (props: any) => {
      return renderNA(props.data.special_flag==1 ? null:props.data.user_email);
    },
  };

  const StatusColumn: ColDef = {
    field: "status",
    headerName: "Status",
    width: 500,
    cellRenderer: (props: any) => {
      return <Tag color={statusFileds(props.data.status, 'color')}>{statusFileds(props.data.status, 'title')}</Tag>;
    },
    filterValueGetter:(props: any) => {
      return renderNA(statusFileds(props.data.status, 'title'));
    },
    tooltipValueGetter:(props: any) => {
      return renderNA(statusFileds(props.data.status, 'title'));
    },
    valueGetter:(props: any) => {
      return statusFileds(props.data.status, 'title');
    },
  };

  

  return [
    { ...idColumn, pinned: null },
    AceessCodeColumn,
    UserEmailColumn,
    StatusColumn,
  ];
};

export default AccessCodeColumnDefs;
